import {Component, OnInit} from '@angular/core';
import {TranslateService} from '../shared/translate.service';
import {InfoPageService} from '../info-pages/info-page.service';
import {CmsHtmlPage} from '../info-pages/cms-html-page';
import {HtmlUtilsService} from "../html-utils/html-utils.service";
import {AuthService} from "../auth/auth.service";
import { Router, RoutesRecognized } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LogRoutingService } from '../log/log-routing.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  cmsPages: CmsHtmlPage[] = [];
  loaded: boolean = false;
  mobileFooterActive = true;
  mobileAgent = false;
  private area: string = 'footer';
  cookiesAccepted = false;
  homePage: boolean = false;

  constructor(private translateService: TranslateService,
              private infoPageService: InfoPageService,
              private htmlUtils: HtmlUtilsService,
              private authService: AuthService,
              private router: Router) {
    this.router.events
      .pipe(
        filter((e: any) => e instanceof RoutesRecognized)
      ).subscribe((e: RoutesRecognized) => {
      this.homePage = LogRoutingService.resolveActionSource(e.url, false) === 'url'
    });
  }

  ngOnInit() {
    this.htmlUtils.mobileBehaviorSubject.subscribe(mobileAgent => {
      this.mobileAgent = mobileAgent;
    });

    this.translateService.languageChanged.subscribe(() => {
      this.initComponent();
    });
    this.initComponent();
    let cAccepted = localStorage.getItem('cookiesAccepted');
    if (cAccepted) {
      this.cookiesAccepted = (cAccepted == 'true');
    }
  }

  private initComponent() {
   this.getComponents();
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  private getComponents(){
    this.authService.isAuthServiceOnline().subscribe(() => {
      this.authService.isLogged.subscribe(value => {
        this.getComponentsByLoginStatus(value);
      });
    }, () => {
      this.getComponentsByLoginStatus(false);
    });

  }

  setCookiesAccepted(): void {
    this.cookiesAccepted = true;
    localStorage.setItem('cookiesAccepted', 'true');
  }

  private getComponentsByLoginStatus(isLogged: boolean){
    this.infoPageService.getComponents(this.area, isLogged)
      .subscribe(results => {
        this.cmsPages = results;
        this.loaded = true;
      }, error => {
        console.error('Cannot load footer links. Reason: ', error);
        this.loaded = false;
      });
  }

}
